@if (form && controlName) {
  <form [formGroup]="form">
    <mat-form-field appearance="outline" floatLabel="always" class="form-field">
      @if (label) {
        <mat-label>Select {{ label }}</mat-label>
      }
      <input
        type="text"
        [placeholder]="placeholder + ' ...'"
        matInput
        [matAutocomplete]="auto"
        [formControlName]="controlName"
        [attr.aria-label]="placeholder"
      />
      <mat-autocomplete
        [displayWith]="displayFn"
        #auto="matAutocomplete"
        (optionSelected)="onFormSelected($event.option.value)"
      >
        @for (option of filteredOptions | async; track option) {
          <mat-option [value]="option">
            {{ option.title }}
          </mat-option>
        }
      </mat-autocomplete>
      @if (form.get(controlName).hasError('invalidAutocomplete')) {
        <mat-error> Invalid {{ label }} name </mat-error>
      }
      @if (
        form.get(controlName).hasError('required') &&
        form.get(controlName).touched
      ) {
        <mat-error> {{ label ?? 'This field' }} is required </mat-error>
      }
    </mat-form-field>
  </form>
}
